import React, { useState, useEffect } from 'react'
import { client } from '../../utils'
import PropTypes from 'prop-types'

export const Competency = props => {
  const [competency, editCompetency] = useState(props.comp.text || '')
  const [isBeingEdited, setIsBeingEdited] = useState(false)

  useEffect(() => {
    editCompetency(props.comp.text)
  }, [props])

  const SubmitCompetency = e => {
    e.preventDefault()
    let data = {
      text: competency,
      sort_order: props.comp.sortOrder,
    }
    client
      .put(`/api_v2/competencies/-/${props.comp.id}`, data)
      .then(resp => {
        console.log(resp)
        props.editCompetency(resp.data.competency)
        setIsBeingEdited(false)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const deleteCompetency = () => {
    client
      .delete(`/api_v2/competencies/-/${props.comp.id}`)
      .then(() => {
        props.removeCompetency(props.comp.id)
        setIsBeingEdited(false)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const sortControls = !isBeingEdited && (
    <div className="mt-1" role="group">
      <table>
        <tbody>
          {props.showUp && (
            <tr>
              <td>
                <a
                  className="btn btn-myed btn-primary btn-primary-myed btn-xs-myed"
                  role="button"
                  onClick={() => {
                    props.move(props.index, -1)
                  }}
                >
                  <span className="fa-regular fa-chevron-up fa-fw" />
                </a>
              </td>
            </tr>
          )}
          {props.showDown && (
            <tr>
              <td>
                <a
                  className="btn btn-myed btn-primary btn-primary-myed btn-xs-myed"
                  role="button"
                  onClick={() => {
                    props.move(props.index, 1)
                  }}
                >
                  <span className="fa-regular fa-chevron-down fa-fw" />
                </a>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )

  const competencyHtml = isBeingEdited ? (
    <form className="tagline" onSubmit={e => SubmitCompetency(e)}>
      <label htmlFor={`comp-${props.comp.id}`}>
        <h4>Competency {props.index + 1}</h4>
      </label>
      <textarea
        onChange={e => editCompetency(e.target.value)}
        id={`comp-${props.comp.id}`}
        className="w-100"
        name="desc"
        type="text"
        value={competency}
        placeholder="Enter competency here..."
      />
      <button className="btn btn-success" type="submit">
        Submit Competency
      </button>
    </form>
  ) : (
    <div>
      <h4>Competency {props.index + 1}</h4>
      {props.comp.text}
    </div>
  )

  const controlButtonText = isBeingEdited ? 'Cancel' : 'Edit'
  const deleteButton = isBeingEdited && (
    <a
      onClick={deleteCompetency}
      className="btn btn-danger pull-right mt-1 mr-2"
    >
      Delete
    </a>
  )
  return (
    <tr style={{ height: '150px', verticalAlign: 'top' }}>
      <td style={{ width: '30px' }}>{sortControls}</td>
      <td className="w-75">{competencyHtml}</td>
      <td>
        <a
          className="btn btn-myed btn-primary btn-primary-myed pull-right mt-1"
          href={`/author/objectives/${props.comp.coursenum}/${props.comp.id}`}
        >
          View
        </a>
        <a
          onClick={() => setIsBeingEdited(!isBeingEdited)}
          className="btn btn-warning pull-right mt-1"
        >
          {controlButtonText}
        </a>
        {deleteButton}
      </td>
    </tr>
  )
}

Competency.propTypes = {
  index: PropTypes.number.isRequired,
  comp: PropTypes.object.isRequired,
  removeCompetency: PropTypes.func.isRequired,
  move: PropTypes.func.isRequired,
  showUp: PropTypes.bool.isRequired,
  showDown: PropTypes.bool.isRequired,
}
